<template>
    <div>
        <!-- BON DISPLAY -->
        <div
            v-if="mainState === 2"
            class="flex flex-col bg-cybo_left_bg"
            style="height: calc(100vh - 60px)"
        >
            <div v-if="state !== 0" class="flex-1 px-3 py-4 overflow-y-auto">
                <img :src="pathToPng" :style="blurBon" alt="" />
            </div>

            <!-- DEFAULT BUTTONS -->
            <div
                v-if="state === 1"
                class="flex flex-col px-3 pt-4 bg-cybo_button_container_bg rounded-t-lg w-100 h-40"
                style="box-shadow: 0px -1px 1px #eceded"
            >
                <button class="button-filled-mobile" @click="increaseState">Speichern</button>
                <button class="button-mobile mt-3" @click="decreaseState">Löschen</button>
            </div>

            <!-- DOWNLOAD BUTTONS -->
            <div
                v-else-if="state === 2"
                class="flex flex-col px-3 pt-3 bg-cybo_button_container_bg rounded-t-lg w-100 h-52"
                style="box-shadow: 0px -1px 1px #eceded"
            >
                <button
                    class="button-light-mobile flex flex-row h-10"
                    @click="triggerDownloadImage"
                >
                    <div class="flex-1"></div>
                    <div class="flex flex-col h-full mr-0">
                        <div class="flex-1"></div>
                        <div class="flex flex-row">
                            <!--
                            <div>
                                <img :src="this.$icons.iconImage" alt="" class="h-5 mt-1 mx-3" />
                            </div>
                            -->
                            <div>Als Bild speichern</div>
                        </div>
                        <div class="flex-1"></div>
                    </div>
                    <div class="flex-1"></div>
                </button>

                <button
                    class="button-light-mobile flex flex-row h-10 mt-1"
                    @click="triggerDownloadPdf"
                >
                    <div class="flex-1"></div>
                    <div class="flex flex-col h-full mr-0">
                        <div class="flex-1"></div>
                        <div class="flex flex-row">
                            <!--
                            <div>
                                <img :src="this.$icons.iconPdf" alt="" class="h-5 mt-1 mx-3" />
                            </div>
                            -->
                            <div>Als PDF speichern</div>
                        </div>
                        <div class="flex-1"></div>
                    </div>
                    <div class="flex-1"></div>
                </button>

                <button class="button-mobile mt-3" @click="decreaseState">Abbrechen</button>
            </div>

            <!-- DELETE CONFIRM -->
            <div v-else-if="state === 0" class="bg-cybo_button_container_bg h-full px-3">
                <div class="text-2xl mt-10">Kassenzettel löschen</div>
                <div class="mt-3">Nach diesem Schritt können Sie diesen nicht mehr abrufen</div>
                <button class="button-filled-mobile mt-20" @click="triggerDeleteBon">
                    LÖSCHEN
                </button>
                <button class="button-mobile mt-4" @click="increaseState">Abbrechen</button>
            </div>
        </div>

        <!-- BON DELETED -->
        <div v-else-if="mainState === 100" class="pt-10 text-cybo_button_text">
            <img :src="this.$icons.iconTrash" alt="" class="mx-auto w-12" />
            <div class="mt-10">Ihr Kassenzettel wurde erfolgreich gelöscht.</div>
        </div>

        <!-- CONNECTION ERROR -->
        <div v-else-if="mainState === -2" class="">
            <div class="text-2xl pt-20">Verbindungsfehler</div>
            <div class="mt-10">Es konnte keine Verbindung zum Server hergestellt werden..</div>
            <div class="px-3">
                <button class="mt-10 button-mobile">Erneut versuchen</button>
            </div>
        </div>

        <!-- URL INVALID -->
        <div v-else-if="mainState === -1">
            <div class="pt-20 text-3xl">404</div>
            <div class="pt-10 px-3">Dieser Link scheint nicht zu funktionieren..</div>
        </div>

        <!-- HASHCODE INVALID -->
        <div v-else-if="mainState === 1">
            <div class="pt-20 text-3xl">404</div>
            <div class="pt-10 px-3">Es konnte kein Kassenzettel gefunden werden..</div>
        </div>

        <!-- WAITING FOR BON CREATION -->
        <div v-else-if="mainState === 0" class="px-3">
            <div class="pt-20">Einen Augenblick Geduld bitte..</div>
            <div
                style="border-top-color: transparent"
                class="
                    mt-10
                    mx-auto
                    w-16
                    h-16
                    border-4 border-blue-400 border-solid
                    rounded-full
                    animate-spin
                "
            ></div>
            <div class="mt-10">Ihr Kassenzettel wird in diesem Moment erzeugt..</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MobilePageCybo',
        data() {
            return {
                // 1 = speichern/löschen, 2 = optionen, 3 = login
                state: 1
            }
        },
        methods: {
            increaseState: function () {
                if (this.state < 3) {
                    this.state++
                }
            },
            decreaseState: function () {
                if (this.state > 0) {
                    this.state--
                }
            },
            triggerDownloadImage: function () {
                this.$emit('triggerDownloadImage')
            },
            triggerDownloadPdf: function () {
                this.$emit('triggerDownloadPdf')
            },
            triggerDeleteBon: function () {
                this.$emit('triggerDeleteBon')
            }
        },
        computed: {
            mobileBonContainerStyle: function () {
                if (this.state === 1) {
                    return 'margin-bottom: 160px'
                } else if (this.state === 2) {
                    return 'margin-bottom: 220px;'
                }
                return 'margin-bottom: 10px;'
            },
            blurBon: function () {
                if (this.state === 3) {
                    return (
                        '-webkit-filter: blur(3px);' + 'position: fixed;' + 'top: 0;' + 'left: 0;'
                    )
                }
                return ''
            }
        },
        props: {
            pathToPng: String,
            mainState: Number
        }
    }
</script>

<style scoped>
    .button-filled-mobile {
        background-color: #002e62 !important;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
        border-radius: 25px;
        border: none;
        width: 100%;
        height: 50px;
        color: #ffffff;
        font-weight: normal;
        font-size: 16px;
    }
    .button-filled-mobile:focus {
        outline: none;
    }

    .button-light-mobile {
        background-color: #d4e1ee !important;
        border-radius: 25px;
        border: none;
        width: 100%;
        height: 50px;
        color: #002e62;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
    }
    .button-light-mobile:focus {
        outline: none;
    }

    .button-mobile {
        background-color: white !important;
        border-radius: 25px;
        border: 1px solid #0f4680;
        width: 100%;
        height: 50px;
        color: #002e62;
        font-weight: normal;
        font-size: 16px;
    }
    .button-mobile:focus {
        outline: none;
    }
</style>